import { render, staticRenderFns } from "./SupplementaryUnitsSection.vue?vue&type=template&id=24c5a210&scoped=true&"
import script from "./SupplementaryUnitsSection.vue?vue&type=script&lang=js&"
export * from "./SupplementaryUnitsSection.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryUnitsSection.vue?vue&type=style&index=0&id=24c5a210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5a210",
  null
  
)

export default component.exports